import { FileText, HelpCircle, Code, MessageSquare } from 'lucide-react';

export function getLessonIcon(type: string) {
  switch (type) {
    case 'content':
      return FileText;
    case 'quiz':
      return HelpCircle;
    case 'exercise':
    case 'project':
      return Code;
    case 'discussion':
      return MessageSquare;
    default:
      return FileText;
  }
}

export function getDifficultyColor(level: string) {
  switch (level) {
    case 'beginner':
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
    case 'intermediate':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
    case 'advanced':
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200';
    case 'expert':
      return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
  }
}
